(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mhn-builders-trade"] && !Shopify.designMode) return;
  try {
    

function initBuildersTrade(scope) {
  scope.querySelectorAll('[data-bt-root]').forEach(root => {
    if (root.dataset.btReady) return;
    root.dataset.btReady = 'true';

    const form = root.querySelector('form');
    const submit = form.querySelector('button[type="submit"]');

    root.querySelectorAll('[data-bt-request],[data-bt-product]').forEach(link => {
      link.addEventListener('click', () => {
        const sample = link.dataset.btRequest === 'sample';

        form.elements['contact[request]'].value = sample
          ? 'Sample request'
          : 'Project quote';

        if (link.dataset.btProduct !== undefined) {
          form.elements['contact[Products]'].selectedIndex =
            Number(link.dataset.btProduct) + 1;
        }

        if (submit) {
          submit.firstChild.textContent = sample
            ? root.dataset.sampleLabel
            : root.dataset.quoteLabel;
        }
      });
    });
  });
}

document.querySelectorAll('[data-bt-root]').forEach(root => {
  root.dataset.quoteLabel =
    root.querySelector('.bt-submit button').firstChild.textContent;

  root.dataset.sampleLabel =
    root.querySelector('[data-bt-request="sample"]').firstChild.textContent;
});

initBuildersTrade(document);

document.addEventListener('shopify:section:load', event => {
  initBuildersTrade(event.target);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mhn-contact"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-mhn-contact]').forEach((section) => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const topic = section.querySelector('[data-contact-topic]');
      const order = section.querySelector('[data-contact-order]');
      if (topic && order) {
        const updateOrder = () => {
          const visible = ['Order support', 'Returns & exchanges'].includes(topic.value);
          order.hidden = !visible;
          order.querySelector('input').disabled = !visible;
        };
        topic.addEventListener('change', updateOrder);
        updateOrder();
      }
      const result = section.querySelector('[data-contact-result]');
      if (result) result.focus();
      const chatButton = section.querySelector('[data-contact-chat]');
      if (chatButton && window.customElements) {
        customElements.whenDefined('shopify-chat').then(() => {
          const chat = document.querySelector('shopify-chat');
          if (!chat || !chatButton.isConnected) return;
          chatButton.hidden = false;
          chatButton.addEventListener('click', () => {
            chat.setAttribute('open', '');
            if (chat.getAttribute('mode') === 'managed') {
              document.querySelector('#chat-drawer')?.open?.();
            }
          });
        });
      }
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reincarvation-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mhn-review-wall')) {
    customElements.define('mhn-review-wall', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelectorAll('[data-wall-original]').forEach(group => {
          if (!group.children.length) return;
          const copy = group.cloneNode(true);
          copy.removeAttribute('data-wall-original');
          copy.setAttribute('data-wall-copy', '');
          copy.setAttribute('aria-hidden', 'true');
       copy.inert = false;
copy.querySelectorAll('a, button').forEach(el => el.setAttribute('tabindex', '-1'));
          copy.querySelectorAll('[data-shopify-editor-block]').forEach(card => card.removeAttribute('data-shopify-editor-block'));
          group.after(copy);
        });
        this.classList.add('is-ready');
        const button = this.querySelector('[data-wall-toggle]');
        button?.addEventListener('click', () => {
          const paused = this.classList.toggle('is-paused');
          button.setAttribute('aria-pressed', String(paused));
          button.textContent = paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        });
        this.addEventListener('shopify:block:select', () => this.classList.add('is-paused'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
